module.exports = __webpack_public_path__ + "images/thumb-up.07da2400d61dae6b88ac.png";